import styled from 'styled-components';

import { mediaConfined } from '@xing-com/layout-tokens';
import {
  spaceS,
  spaceXL,
  spaceXXL,
  space4XL,
  space6XL,
} from '@xing-com/tokens';
import { BodyCopy as BaseBodyCopy } from '@xing-com/typography';

const BodyCopy = styled(BaseBodyCopy)`
  margin: ${spaceS} 0 ${spaceXXL};
`;

const Section = styled.section`
  text-align: center;
  padding: ${spaceXL} ${spaceXL} ${space4XL};
  @media ${mediaConfined} {
    padding: ${space4XL} ${space4XL} ${space6XL};
  }
`;

export const Styled = { BodyCopy, Section };
